import { CalcsIrRowsController } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * Component for showing tabulator based report of ir rows of given calculations
 * @example
 * ```html
 * <salaxy-calcs-ir-rows calcs="[calc1,calc2]" lang="fi"></salaxy-calcs-ir-rows calcs
 * ```
 */
export class CalcsIrRows extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */

  public bindings = {
    /** Calculations for report. */
    calcs: "<",
    /** The language of report. */
    lang: "<"
  };

  /** Uses the CalcsIrRowsController */
  public controller = CalcsIrRowsController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/calc/rows/CalcsIrRows.html";

}
